// src/pages/RecorderPage.jsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SingleQuestionRecorder from '../Utility/SingleQuestion';
import { submitTestInBackground } from './SubmitTest';

const RecorderPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 1. Retrieve the state passed from the previous page
  // We expect: { questions: [...], topicName: "...", topicId: "..." }
  const { state } = location;
  const { questions, topicName, testId } = location.state || {};
  const [isChecking, setIsChecking] = useState(false);

  // 2. Safety Redirect: If no state exists (user refreshed or pasted URL directly)
  useEffect(() => {
    if (!state || !state.questions || !state.testId) {
      alert("No test data found. Try Loading Again...");
      navigate(-1); // Or back to the topic selector
    }
  }, [state, navigate]);

  // If state is missing (before redirect happens), render nothing or a loader
  if (!state || !state.questions || !state.testId) {
    return null;
  }


  const handleSubmit = async () => {
    try {
      setIsChecking(true)
      await submitTestInBackground({
        testId,
        questions: questions.map((q, i) => ({
          id: q.id,
          index: i + 1,
        })),
      });
      setIsChecking(false)

      navigate('/result', {
        state: {
          testId: testId
        }
      }, { replace: true });
    } catch (err) {
      setIsChecking(false);
      alert(err.message || 'Submission failed. Try again.');
    }
  };


  return (
    <div className="p-6 max-w-4xl mx-auto min-h-screen">
      {isChecking && (
                <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-lg shadow-xl flex flex-col items-center">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4"></div>
                        <p className="font-semibold text-gray-700">Submitting the Test...</p>
                    </div>
                </div>
            )}

      {/* Header / Title */}
      <div className="mb-8 border-b pb-4">
        <h2 className="text-gray-500 text-sm uppercase tracking-wider font-semibold">
          Practice Test
        </h2>
        <h1 className="text-3xl font-bold text-gray-900 mt-1">
          {topicName}
        </h1>
        <p className="text-gray-500 mt-2 text-sm">
          {questions.length} Questions
        </p>
        <p className="text-red-500 mt-2 text-base">
          I. Audio Answers or Reply more than 5 minutes will not be processed by backend and will be discarded.
        </p>
        <p className="text-red-500 mt-2 text-base">
          II. Explain important steps and process of each solutions, Direct answer will be rejected and will be considered copied answer.
        </p>
        <p className="text-red-500 mt-2 text-base">
          III. Avoid Noisy Enviroments while answering.
        </p>
        <p className="text-red-500 mt-2 text-base">
          IV. Verify your audio after recording by playing once.
        </p>
        <p className="text-red-500 mt-2 text-base">
          V. While all questions are mandatory to answer without which submission will not happen, if u can not solve any question, simply record "I don't know the answer of this." and then submit.
        </p>
      </div>

      {/* Questions List */}
      <div className="space-y-8">
        {questions.map((q, index) => (
          <SingleQuestionRecorder
            key={q.id || index}
            question={q}
            index={index + 1} // Optional: Pass index if you want to number them (1, 2, 3...)
          />
        ))}
      </div>

      {/* Submit Button */}
      <div className="mt-12 flex justify-center pb-10">
        <button
          onClick={handleSubmit}
          className="bg-black text-white font-bold px-10 py-4 rounded-xl hover:bg-gray-800 transition shadow-lg hover:shadow-xl active:scale-95"
        >
          Submit Test
        </button>
      </div>
    </div>
  );
};

export default RecorderPage;